module.exports = __webpack_public_path__ + "static/media/myPrivilegesIcon.6702034f.svg";